import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

export const businessMergeEventsSerializeMap: SerializeMap<BusinessMergeEvents> =
  {
    id: "id",
    lastModified: "last_modified",
    notes: "notes",
    sourceBusiness: "source_business",
    status: "status",
    targetBusiness: "target_business",
    user: "user",
    created: "created",
  };

export const serializeBusinessMergeEvents = buildSerializer(
  businessMergeEventsSerializeMap,
  "BusinessMergeEvents",
);

export const deserializeBusinessMergeEvents = buildDeserializer(
  businessMergeEventsSerializeMap,
  "BusinessMergeEvents",
);
